export default __webpack_public_path__ + "static/balgam-c40006d7c567a61e896b239c97f14f2e.png";